import { Text } from "@hangar/web-components/core/Text";
import * as S from './styles/DetailItem.style';
import { DetailItemProps } from './types';

const DetailItem = ({ value, label, isValueBold = false }: DetailItemProps) => {
    return (
    <S.Container>
        <Text variant="body-lg" bold={isValueBold}>{value}</Text>
        <Text variant="body-sm" color="secondary">{label}</Text>
    </S.Container>
  );
};

export default DetailItem;